module.exports = __webpack_public_path__ + "img/arrow_up_white_32dp@2x.7e114ad7.png";